import { http } from "@/utils/request";
import type {
  OrdersResponse,
  GetOrdersParams,
  RefundParams,
  RefundResponse,
  Order,
} from "@/types/order";

export const orderService = { 
  // 获取订单列表
  getOrders: async (
    params: GetOrdersParams
  ): Promise<OrdersResponse> => {
    return http.get<OrdersResponse>("/order/list", params);
  },

  // 导出订单列表
  exportOrders: async (params: GetOrdersParams): Promise<Blob> => {
    return http.get<Blob>("/order/export", params, {
      responseType: "blob",
    });
  },
  // 退款请求
  refundForUser: async ({id,params}: {id: string;params: RefundParams}):Promise<RefundResponse> => {
    return http.post<RefundResponse>(`/order/refund/${id}`,params)
  },
  // 获取订单详细信息
  getOrderDetail: async ({id}: {id: string}): Promise<Order> => {
    return http.get(`/order/${id}`)
  }
};
